module.exports = __webpack_public_path__ + "02_very_short_black.ed8b51a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_very_short_black.png
// module id = f7YU
// module chunks = 0